import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            Explore Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Discover a wide range of products available through BaseTao Spreadsheet. Browse by category to find exactly what you need.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {/* Category Image */}
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  title={`${cat.name} - BaseTao Spreadsheet Category`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
              </div>
              {/* Category Label */}
              <div className="flex items-center gap-2 px-3 py-3">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                  <i className={`${cat.icon} text-xs text-primary-600`}></i>
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors leading-tight">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}